import { MenuItem, Select } from '@material-ui/core'
import React from 'react'

export function SelectComponent(props: { value: string; callback: Function; items: string[]; index?: number; disabled?: boolean }) {
  const { value, callback, items, index, disabled } = props

  function callbackWithEvent(e: any) {
    callback(e.target.value, index)
  }

  function renderItems() {
    const found = items.find(item => item === value)
    if (!found) {
      items.unshift(value)
    }
    return items.map((item, itemIndex) => (
      <MenuItem key={itemIndex} value={item}>
        {item}
      </MenuItem>
    ))
  }

  return (
    <Select disabled={disabled} value={value} onChange={callbackWithEvent}>
      {renderItems()}
    </Select>
  )
}
